// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tuqarhetglkawdnniyuz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR1cWFyaGV0Z2xrYXdkbm5peXV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NzM1NzUsImV4cCI6MjA2OTU0OTU3NX0.8xiEvIip75VSQYnU7Vpdersf6ZyYXA9WuhTCXMxroxc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});